import {exibirMensagem, exibirMensagemErro, HttpVerbo, xfetch} from "../util";
import {Forca} from "../tipos/forca";
import {CursoCmd} from "../tipos/cmd/curso-cmd";
import {Curso} from "../tipos/curso";
import {CadastrarInscricaoCursoCmd} from "../tipos/cmd/cadastrar-inscricao-curso-cmd";
import {Inscricao} from "../tipos/Inscricao";

const url = '/curso'

export default class CursoServico {

  static buscarCursos = async (): Promise<Curso[]> => {
    let res =
      await xfetch(url, {}, HttpVerbo.GET)
    return res.json();
  }

  static buscarCursosAbertos = async (): Promise<Curso[]> => {
    let res =
      await xfetch(url+'/abertos', {}, HttpVerbo.GET)
    return res.json();
  }

  static listarInscritos = async (idCurso: number): Promise<Inscricao[]> => {
    let res =
      await xfetch(url+`/${idCurso}`, {}, HttpVerbo.GET)
    return res.json();
  }

  static salvarCurso = async (cmd: CursoCmd): Promise<Curso> => {
    let res =
      await xfetch(url, cmd, HttpVerbo.POST)
    return res.json();
  }

  static inscreverCurso = async (cmd: CadastrarInscricaoCursoCmd): Promise<Curso> => {
    let res =
      await xfetch(url+'/inscrever', cmd, HttpVerbo.POST)
    return res.json();
  }
  static alterarCurso(dados: Forca) {
    return xfetch(url, dados, HttpVerbo.PUT).catch(e => exibirMensagem(e.message))
  }

  static deletarCurso(id: number) {
    return xfetch(url+'/deletar', {idCurso: id}, HttpVerbo.POST).catch(e => exibirMensagemErro(e.message))
  }

  static sortearInscritos = async (idCurso: number): Promise<Inscricao[]> => {
      return await xfetch(url+`/sortear/${idCurso}`, {}, HttpVerbo.POST).then(res => res.json())
  }
}
